
















import Vue, { PropType } from 'vue';
import { IconData } from '@/icons';

import Icon from '@/components/Icon.vue';

export default Vue.extend({
  components: {
    Icon
  },

  props: {
    topLabel: {
      type: String,
      required: false
    },
    bottomLabel: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    iconData: {
      type: Object as PropType<IconData>,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    largeWithDefault(): boolean {
      return this.large || !(this.small || this.medium);
    },
    classes(): string[] {
      if (this.large) {
        return ['round-me', 'py-2', 'px-5'];
      }
      return ['round-me', 'py-2', 'px-4'];
    }
  }
});
